import React from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import { TableCell, TableRow } from '@/components/ui/table';
import { cn } from '@/lib/utils';
import type { Countermeasure } from '../../../types';
import {
  SCORE_CELL,
  getCountermeasureTypeVariant,
  getPriorityVariant,
} from './drbfmTableFormat';

const CountermeasureRow: React.FC<{ row: Countermeasure }> = ({ row }) => {
  const { t } = useTranslation();

  return (
    <TableRow>
      <TableCell>
        <Badge variant={getCountermeasureTypeVariant(row.countermeasureType)} className="revy-cjk">
          {t(`drbfm.countermeasureType.${row.countermeasureType?.toLowerCase()}`)}
        </Badge>
      </TableCell>
      <TableCell>
        <p
          className="revy-cjk max-w-[400px] text-sm leading-[1.6]"
          title={row.description || ''}
        >
          {row.description}
        </p>
      </TableCell>
      <TableCell className="text-center">
        <span
          className={cn(
            SCORE_CELL,
            (row.effectivenessScore || 0) >= 8 ? 'text-success' : 'text-foreground',
          )}
        >
          {row.effectivenessScore || '-'}
        </span>
      </TableCell>
      <TableCell className="text-center">
        <Badge variant={getPriorityVariant(row.priority)} className="revy-figure">
          {`P${row.priority || '-'}`}
        </Badge>
      </TableCell>
    </TableRow>
  );
};

export default CountermeasureRow;
